(function () {

    angular.module('app')
        .directive('ngAddtiptap', ["$timeout", "$uibModal", "$sce", "AiService", function ($timeout, $uibModal, $sce, AiService) {

            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {

                    let editor = null;
                    scope.showHtml = false;
                    scope.curLang = 'es';

                    scope.changeLang = function (lang) {
                        scope.curLang = lang;
                        if (editor) {
                            editor.view.dom.setAttribute('lang', lang);
                            editor.commands.focus();
                        }
                    };

                    scope.corregir = function () {
                        if (!editor) return;
                        
                        const currentHtml = editor.getHTML();
                        if (!currentHtml || currentHtml === '<p></p>') return;

                        const langNames = { 'es': 'español', 'ca': 'catalán', 'pt': 'portugués','en':'Inglés' };
                        const langName = langNames[scope.curLang] || 'español';

                        scope.correcting = true;

                        AiService.processTiptap("Actúa como un corrector experto. Corrige la ortografía y gramática de este texto en " + langName + ". Mantén exactamente el mismo formato HTML, clases y etiquetas. No añadas comentarios, solo devuelve el HTML corregido.", currentHtml)
                            .then(function (data) {
                                if (data && data.text) {
                                    editor.commands.setContent(data.text);
                                }
                            }).finally(function() {
                                scope.correcting = false;
                            });
                    };

                    scope.toggleHtml = function () {
                        scope.showHtml = !scope.showHtml;
                        if (!scope.showHtml && editor) {
                            $timeout(() => {
                                editor.commands.focus();
                            });
                        }
                    };

                    function runAI() {

                        if (!editor) return;

                        $uibModal.open({
                            animation: true,
                            templateUrl: 'modal-tiptap-ai.html',
                            controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
                                $scope.prompt = '';
                                $scope.loading = false;
                                $scope.result = '';
                                $scope.resultSce = '';

                                $scope.generar = function () {
                                    $scope.loading = true;
                                    $scope.result = '';

                                    AiService.processTiptap($scope.prompt, editor.getHTML())
                                        .then(function (data) {
                                            if (data && data.text) {
                                                $scope.result = data.text;
                                                $scope.resultSce = $sce.trustAsHtml($scope.result);
                                                ngModel.$setViewValue($scope.result);
                                            } else if (data && data.error) {
                                                alert("Error de IA: " + data.error);
                                            }
                                        }).catch(function (err) {
                                            console.error('AI error', err);
                                            alert("Error al conectar con el servicio de IA");
                                        }).finally(function () {
                                            $scope.loading = false;
                                        });
                                };

                                $scope.aceptar = function () {
                                    $uibModalInstance.close($scope.result);
                                };

                                $scope.cancelar = function () {
                                    $uibModalInstance.dismiss('cancel');
                                };
                            }]
                        }).result.then(function (newContent) {
                            if (newContent) {
                                editor.commands.setContent(newContent);
                            }
                        }, function () {
                            // Modal dismissed
                        });
                    }

                    function wait(cb) {
                        const check = () => {
                            if (window.TipTapInit) cb();
                            else setTimeout(check, 50);
                        };
                        check();
                    }

                    $timeout(function () {

                        wait(function () {

                            editor = window.TipTapInit(
                                element[0],
                                ngModel.$viewValue || '',
                                function (html) {
                                    scope.$applyAsync(function () {
                                        ngModel.$setViewValue(html);
                                    });
                                },
                                function () {
                                    scope.$applyAsync();
                                }
                            );

                            // guardar editor en scope
                            scope.editor = editor;

                            // =========================
                            // COMMANDS
                            // =========================
                            scope.cmd = function (type) {

                                const chain = editor.chain().focus();

                                switch (type) {

                                    case 'bold':
                                        chain.toggleBold().run();
                                        break;

                                    case 'italic':
                                        chain.toggleItalic().run();
                                        break;

                                    case 'underline':
                                        chain.toggleUnderline().run();
                                        break;

                                    case 'strike':
                                        chain.toggleStrike().run();
                                        break;
                                    case 'ai':
                                        runAI();
                                        break;
                                    case 'html':
                                        scope.toggleHtml();
                                        break;

                                    case 'h1':
                                        chain.toggleHeading({ level: 1 }).run();
                                        break;

                                    case 'h2':
                                        chain.toggleHeading({ level: 2 }).run();
                                        break;

                                    case 'bulletList':
                                        chain.toggleBulletList().run();
                                        break;

                                    case 'orderedList':
                                        chain.toggleOrderedList().run();
                                        break;

                                    case 'clear':
                                        chain.clearNodes().unsetAllMarks().run();
                                        break;

                                    case 'link':
                                        if (editor.isActive('link')) {
                                            chain.unsetLink().run();
                                        } else {
                                            const url = prompt('URL:');
                                            if (url) {
                                                chain.setLink({ href: url }).run();
                                            }
                                        }
                                        break;

                                    case 'insertTable':
                                        chain.insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run();
                                        break;
                                    case 'addColumnBefore':
                                        chain.addColumnBefore().run();
                                        break;
                                    case 'addColumnAfter':
                                        chain.addColumnAfter().run();
                                        break;
                                    case 'deleteColumn':
                                        chain.deleteColumn().run();
                                        break;
                                    case 'addRowBefore':
                                        chain.addRowBefore().run();
                                        break;
                                    case 'addRowAfter':
                                        chain.addRowAfter().run();
                                        break;
                                    case 'deleteRow':
                                        chain.deleteRow().run();
                                        break;
                                    case 'deleteTable':
                                        chain.deleteTable().run();
                                        break;
                                    case 'mergeCells':
                                        chain.mergeCells().run();
                                        break;
                                    case 'splitCell':
                                        chain.splitCell().run();
                                        break;
                                    case 'toggleHeaderCell':
                                        chain.toggleHeaderCell().run();
                                        break;
                                }
                            };

                            // =========================
                            // ACTIVE STATE
                            // =========================
                            scope.isActive = function (type, opts) {

                                if (!editor) return false;

                                switch (type) {
                                    case 'bold':
                                    case 'italic':
                                    case 'underline':
                                    case 'strike':
                                    case 'bulletList':
                                    case 'orderedList':
                                    case 'table':
                                    case 'link':
                                        return editor.isActive(type);
                                    case 'heading':
                                        return editor.isActive('heading', opts);
                                    default:
                                        return false;
                                }
                            };

                            ngModel.$render = function () {
                                const value = ngModel.$viewValue || '';
                                if (editor && editor.commands) {
                                    // Solo actualizamos si el contenido es realmente diferente para evitar loops o pérdida de foco
                                    if (editor.getHTML() !== value) {
                                        editor.commands.setContent(value, false);
                                    }
                                }
                            };

                            // destroy
                            scope.$on('$destroy', function () {
                                if (editor) editor.destroy();
                            });

                        });

                    });

                }
            };

        }])

})();